import type {ReactElement} from "react";

export interface LinkTreeButtonProps {
    href: string;
    name: string;
    Icon: ReactElement;
    classNames: string; //for customizing container styles
}
